import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface DisableIPConfirmModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DisableIPConfirmModal: React.FC<DisableIPConfirmModalProps> = ({
  show,
  onClose,
  onConfirm,
}) => {
   const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("Disable IP Verification")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
          {t("Are you sure you want to disable IP address verification? This will allow logins from any IP address.")}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("Cancel")}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {t("Yes, Disable")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}; 

export default DisableIPConfirmModal;
